export default {
      id: "info-black-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "sprite.svg#info-black",
      toString: function () {
        return this.url;
      }
    }